import ReactDOM from "react-dom";
import { useState } from "react";

import { useNavigate } from "react-router-dom"

import LogoWhite from '../../icons/logoWhite.'
import Button from '../common/Button'
import Card from "../common/Card"

import Modal from "../common/Modal";
import PannelHeader from "../fragments/PannelHeader";
import ForgotPassword from "./ForgotPassword";
import PannelBody from "../fragments/PannelBody";
import { getSystemAlerts, getSystemSettings, getUser, userLogin, getRecentCases, getUserWorkQueueViews } from "../../lib/fetchApi";
import { useDispatch } from "react-redux";
import { notificationActions } from "../../store/notifications";
import { userActions } from "../../store/user";
import { reduceToIdArray, setStorageItem } from "../../lib/script";
import { clearWorkQFiltersAndRecentCases } from "../../lib/filters";
import { filterActions } from "../../store/filter";
import { tasksActions } from "../../store/tasks";
import InputBoxLogin from "../common/interactive/InputBoxLogin";

import classes from './Login.module.css'
import { permissionsActions } from "../../store/permissions";
import Backdrop from "../common/modal/Backdrop";
import { systemActions } from "../../store/system";

const Login = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [showForgotPass, setShowForgotPass] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const forgotPasswordHandler = () => {
        setShowForgotPass(prevState => prevState = !prevState)
    }
    
    
    const authHandler = async (event) => {
        event.preventDefault()
        setIsLoading(true)
        try {
        const fd = new FormData(event.target)

        const data = Object.fromEntries(fd.entries())

        const login = await userLogin({
            email: data.user_email,
            password: data.user_password
        })       
        
        console.log('login', login)
        

        if (login?.errorMessage) {

            if (login?.response?.data?.message == "Invalid credentials" ) {
                dispatch(notificationActions.setError({
                    errorMessage: "Your credentials are incorrect, please try again or use the Forgot Password functionality. After three unsuccessful attempts, your computer will be locked for 30 minutes.",
                    timeOut: 5000
                }))
            } else {
                dispatch(notificationActions.setError(login))     
            }
        } else {            
            dispatch(userActions.setToken(login.token))

            localStorage.setItem('token', login.token)

            clearWorkQFiltersAndRecentCases()
            dispatch(filterActions.resetSavedViews())
            dispatch(tasksActions.resetPersistedListState())

            const [user, systemSettings, recentCases, savedViews] = await Promise.all([
                getUser(login.token),
                getSystemSettings(login.token),
                getRecentCases(login.token),
                getUserWorkQueueViews(login.token),
            ])

            

            setStorageItem('settings', systemSettings)
            dispatch(systemActions.bumpSettingsRevision())
            
            if (user && user.errorMessage) {
                dispatch(notificationActions.setError(user)) 
            } else {  

                dispatch(permissionsActions.setEditPermissions(user.permissions))
                setStorageItem('user', user)
                dispatch(userActions.setUser(user))

                if (user.locations && user.locations.length) {
                    setStorageItem('userLocations', reduceToIdArray(user?.locations))
                    dispatch(userActions.setUserLocations(reduceToIdArray(user?.locations)))
                }

                const systemAlerts = await getSystemAlerts(login.token)
                if (systemAlerts && !systemAlerts.errorMessage) {
                    setStorageItem('persistentSystemAlerts', systemAlerts)
                    dispatch(systemActions.setSystemAlerts(systemAlerts))
                }

                if (recentCases && !recentCases.errorMessage) {
                    setStorageItem('recentCases', recentCases)
                }

                dispatch(filterActions.setSavedViews(
                    savedViews && !savedViews.errorMessage && savedViews.views
                        ? savedViews.views
                        : {}
                ))


                navigate(`/dashboard`, {replace: true});
            }          
            
            
            
        }
        } finally {
            setIsLoading(false)
        }
    }

    return <div className={classes.login_pannel}>
        <div className={classes.login_pannel_inner}>
            <div className={classes.login_pannel_logo}>
                <LogoWhite />
            </div>
            <Card>
                <PannelHeader  padding='large'>
                    <h1>User Login</h1>
                </PannelHeader>
                <PannelBody  padding='large'>
                    <form onSubmit={authHandler}>
                        <div className="row">
                            <InputBoxLogin label="Email Address" type="email" name="user_email" required={true} placeholder="" icon='ti ti-mail'/>
                        </div>
                        <div className="row">
                            <InputBoxLogin label="Password" type="password" name="user_password" autocomplete="User Password" required={true} placeholder="" icon="ti ti-password-user" passView={true}/>
                        </div>                        
                        <div className={classes.forgot_pass_container}>
                            <Button type='button' btnStyle='btn_text' click={forgotPasswordHandler}>Forgot password?</Button>
                        </div>
                        <div className={classes.form_footer}>
                            <Button type='submit' isLoading={isLoading} width={'full'} bypassisCaseArchived={true}>
                                Login 
                                <i className="ti ti-chevron-right"></i>
                            </Button>
                        </div>
                    </form>
                </PannelBody>
            </Card>
        </div>

        {showForgotPass && <>
            {ReactDOM.createPortal(
                <Backdrop hide={forgotPasswordHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ForgotPassword close={forgotPasswordHandler}/>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
        
    </div>
}

export default Login